define('viewModels/privileged/composer/forms/formEditor/FormEditorState',[
    'lib/knockout',
    'util/composer/editorStateUtil'
], function FormEditorState(ko, editorStateUtil) {
    "use strict";

    /*
        Singleton that holds the state of the Form Editor.  Allows components to share a single observable, rather than having a tree of related observables.
    */


    var PREVIEW_STATE = "preview";
    var EDIT_STATE = "edit";
    var EVALUATOR_ACTION_STATE = "evaluator-action";
    var AGENT_REVIEW_STATE = "agent-review";
    var FINISHED_REVIEW_STATE = "finished";

    return function () {
        //Private observable containing the state
        var modeState = ko.observable();

        //are there any changes to the evaluation form to save
        var isModified = ko.observable(false);

        var formEditorState = {

            //form state observables - shared by evaluation, question groups, and questions
            modes: {
                //isPreviewMode - whether or not the evaluation is in preview mode
                // Preview mode is when a user tries out an evaluation to observe the
                // effects of answering questions.  It is typically used during evaluation
                // construction after some work has been done on the evaluation.
                // In preview mode, questions are not editable, but all questions can be
                // answered.  Scores are displayed.  Question comments and overall comments
                // can be modified, but agent comments aren't visible.
                isPreviewMode: ko.computed(function () {
                    return modeState() === PREVIEW_STATE;
                }),

                //isEditMode - whether or not the evaluation is in edit mode.
                // Edit mode is when the user constructs/modifies the evaluation.
                // In edit mode, questions, question groups, and the evaluation can be
                // modified.  No scores are displayed.  Questions cannot be answered, nor
                // can any comments be modified.
                isEditMode: ko.computed(function () {
                    return modeState() === EDIT_STATE;
                }),

                //isEvaluatorActionMode - whether or not the evaluation is in evaluator action mode.
                // Evaluator action mode is when an evaluator will answer the evaluation's questions.
                // In evaluator action mode, questions are not editable, but all questions can be answered,
                // No scores are displayed. Agent comments are not visible, but question
                // and overall comments can be changed.
                isEvaluatorActionMode: ko.computed(function () {
                    return modeState() === EVALUATOR_ACTION_STATE;
                }),

                //isAgentReviewMode - whether or not the evaluation is in agent review mode
                // In agent review mode, all questions are not editable, and question
                // answers are read-only, as are question and overall comments.  Scores are
                // displayed.  Only agent comments can be changed.
                isAgentReviewMode: ko.computed(function () {
                    return modeState() === AGENT_REVIEW_STATE;
                }),

                isFinishedReviewMode: ko.computed(function () {
                    return modeState() === FINISHED_REVIEW_STATE;
                })
            },
            setPreviewMode: function () {
                modeState(PREVIEW_STATE);
            },
            setEditMode: function () {
                modeState(EDIT_STATE);
            },
            setEvaluatorActionMode: function () {
                modeState(EVALUATOR_ACTION_STATE);
            },
            setAgentReviewMode: function () {
                modeState(AGENT_REVIEW_STATE);
            },
            setFinishedReviewMode: function () {
                modeState(FINISHED_REVIEW_STATE);
            },

            //selectedItem - a string that uniquely identifies the currently selected viewModel
                //shared by evaluation, question groups, and questions.
            selectedItem: ko.observable(null),

            selectedAddQuestionBar: ko.observable(null),

            //shouldShowSubmitErrors: a boolean that indicates whether submit validation
            // errors should be displayed.
            shouldShowSubmitErrors: ko.observable(false),

            validationErrors: ko.observableArray(),

            //isModified - whether or not the evaluation has local changes that haven't been saved
            isModified: isModified,

            /**
             * Helper function that creates a ViewModel.computed that reads and writes to an observable,
             * but updates the modified form editor state when written.  Example:
             *   self.someProp = formEditorState.trackModified(self, model.someProp);
             */
            trackModified: editorStateUtil.generateTrackModified(isModified), //returns: function(viewModel, trackedObservable)


            //
            // Live Scoring
            //
            //hasScoreChanged - whether or not the evaluation has local multi-choice answers that haven't been scored
            hasScoreChanged: ko.observable(false),

            questionTemplates: ko.observableArray([]),
            favoriteTemplateIds: ko.observableArray([])
        };

        return formEditorState;
    };
});

